import { FC, ChangeEventHandler } from 'react'

type Props = {
  onChange: ChangeEventHandler<HTMLInputElement>
}
export const FileInput: FC<Props> = ({ onChange }) => (
  <input accept="image/*" hidden onChange={onChange} type="file" multiple={false} />
)
